<template>
  <div class="footer">
    <el-row>
      <el-col :span="12">
        <div>
          <p class="footer-text">
            <strong>
              MOSIA - Backoffice e Gestão de Conteúdo.
              <br/>
            </strong>
            Desenvolvido por Mobile Saúde ® {{ getYear }}
            <br/>
            <a class="footer-text-muted">versão 1.0</a>
          </p>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="footer-img">
          <img class="footer-logo" src="@/assets/img/logo/logo_horizontal_cor.png"/>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'OmniFooter',
  data () {
    return {}
  },
  computed: {
    getYear () {
      const d = new Date()
      return d.getFullYear()
    }
  }
}
</script>
<style scoped lang="sass">
  @import './Footer.scss'
</style>
